import { Col, SelectField } from '@/components';
import type { AnalysisSearchFormType } from '@/features/search/_models/analysis-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { AnalysisAxisLabelModifier, analysisAxisEnum } from '@/utils/enum';
import { type FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const options = analysisAxisEnum.options.flatMap((value) => {
  if (value === 'year') {
    return [];
  }
  return [
    {
      value,
      label: AnalysisAxisLabelModifier[value],
    },
  ];
});

export const AnalysisAxisColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext<AnalysisSearchFormType>();

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <SelectField
        name="analysisAxis"
        label={t('axis-of-analysis')}
        control={control}
        options={options}
        errors={errors}
      />
    </Col>
  );
});
